<div
  class="body"
  role="dialog"
  aria-modal="true"
  aria-labelledby="filter-dialog-title"
>
  <div class="row">
    <h3 id="filter-dialog-title">Filter</h3>
    <button mat-icon-button aria-label="close dialog" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <p class="subtitle">
    Select the regions or markets you want to include in your view
  </p>

  <div class="filter-type-selection" *ngIf="!isLoading; else loadingTemplate">
    <span>
      <input
        type="radio"
        name="filter-type"
        value="region"
        [(ngModel)]="typeSelected"
        id="filter-by-region"
      />
      <label for="filter-by-region">By region</label>
    </span>

    <span>
      <input
        type="radio"
        name="filter-type"
        value="market"
        [(ngModel)]="typeSelected"
        id="filter-by-market"
      />
      <label for="filter-by-market">By market</label>
    </span>

    <div class="checkbox-container regions" *ngIf="typeSelected === 'region'">
      <legend class="filter-title">Select regions:</legend>
      <span>
        <input
          type="checkbox"
          name="region-checkbox-all"
          id="region-checkbox-all"
          (click)="toggleAllRegions()"
          [checked]="isEveryRegionSelected()"
        />
        <label for="region-checkbox-all">All</label>
      </span>
      <span *ngFor="let region of regions">
        <input
          type="checkbox"
          id="checkbox-region-{{ region.id }}"
          [(ngModel)]="region.isSelected"
        />
        <label for="checkbox-region-{{ region.id }}">{{ region.name }}</label>
      </span>
    </div>

    <div class="checkbox-container markets" *ngIf="typeSelected === 'market'">
      <legend class="filter-title">Select markets:</legend>

      <mat-accordion>
        <mat-expansion-panel *ngFor="let region of regions">
          <mat-expansion-panel-header>
            <mat-panel-title>{{ region.name }}</mat-panel-title>
          </mat-expansion-panel-header>
          <div class="filter-container">
            <span>
              <input
                type="checkbox"
                id="checkbox-market-all-{{ region.id }}"
                [checked]="isEveryMarketInRegionSelected(region.id)"
                (click)="toggleAllMarketsInRegion(region.id)"
              />
              <label for="checkbox-market-all-{{ region.id }}">All</label>
            </span>
            <ng-container *ngFor="let market of markets">
              <span *ngIf="market.region === region.id">
                <input
                  type="checkbox"
                  id="checkbox-market-{{ market.id }}"
                  [(ngModel)]="market.checked"
                />
                <label for="checkbox-market-{{ market.id }}">{{
                  market.name
                }}</label>
              </span>
            </ng-container>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </div>

  <hr />
  <div class="dialog-buttons">
    <button class="secondary" (click)="close()" type="button">Cancel</button>
    <button
      class="fill"
      [disabled]="isApplyDisabled()"
      (click)="save()"
      type="button"
    >
      Apply
    </button>
  </div>
</div>

<ng-template #loadingTemplate>
  <div class="loading-container">
    <app-spinner
      [display]="true"
      [class]="'spinner-container'"
      [messageToDisplay]="'Loading data...'"
    ></app-spinner>
  </div>
</ng-template>
